import * as Yup from 'yup';

/**
 * Validation schema for Social Service form.
 * Uses Yup for form validation.
 * @type {Yup.ObjectSchema}
 */

export const childInformationValidationSchema = Yup.object().shape({
  // House ownership status
  isHouseOwner: Yup.string()
    .required('This is required'),
  isHouseOwnerDetails: Yup.string()
    .required('This is required'),

  isHouseOwnerDetailsOthers: Yup.string()
    .when('isHouseOwnerDetails', (isHouseOwnerDetails, schema) => {
      return isHouseOwnerDetails == 'Iba pa'
        ? schema.required('This is required')
        : schema;
    }),

  // Room possession status
  selectRoomPossession: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Room possession is required'),
        secondaryOptions: Yup.array().of(Yup.string()),
        selectedSecondaryOption: Yup.string().required('This is required'),
      })
    )
    .min(3, 'Kailangan pumili ng hindi bababa sa 3.')
    .required('Kailangan pumili ng hindi bababa sa 3.'),

  // Appliances owned
  appliancesOwned: Yup.array()
    .of(
      Yup.object().shape({
        item: Yup.string().required('This is required'),
        type: Yup.string().required('This is required'),
        obtained: Yup.string().required('This is required'),
        periodOfOwned: Yup.string().required('This is required'),
      })
    )
    .required('At least one room possession is required'),

  // Monthly Expenses
  dailyFood: Yup.number()
    .typeError('Daily food expense must be a valid number')
    .min(0, 'Amount cannot be negative')
    .required('This is required'),
  monthlyMedicine: Yup.number()
    .typeError('Monthly medicine expense must be a valid number')
    .min(0, 'Amount cannot be negative')
    .notRequired(),
  monthlyGrocery: Yup.number()
    .typeError('Monthly grocery expense must be a valid number')
    .min(0, 'Amount cannot be negative')
    .notRequired(),
  monthlyInsurance: Yup.number()
    .typeError('Monthly insurance expense must be a valid number')
    .min(0, 'Amount cannot be negative')
    .notRequired(),
  monthlyTherapy: Yup.number()
    .typeError('Monthly therapy expense must be a valid number')
    .min(0, 'Amount cannot be negative')
    .notRequired(),
  monthlyOnlineShopping: Yup.number()
    .typeError('Monthly online shopping expense must be a valid number')
    .min(0, 'Amount cannot be negative')
    .notRequired(),
  monthlyHygiene: Yup.number()
    .typeError('Monthly hygiene expense must be a valid number')
    .min(0, 'Amount cannot be negative')
    .notRequired(),

  monthlyRent: Yup.number()
    .typeError('Monthly rent must be a valid number')
    .min(0, 'Amount cannot be negative')
    .required('This is required'),
  monthlyAllowance: Yup.number()
    .typeError('Monthly allowance must be a valid number')
    .min(0, 'Amount cannot be negative')
    .required('This is required'),

  // Agreement
  agreement: Yup.string().required('You must select Yes or No'),

});